import { render, staticRenderFns } from "./Orphans.vue?vue&type=template&id=add44d0a&scoped=true"
import script from "./Orphans.vue?vue&type=script&lang=js"
export * from "./Orphans.vue?vue&type=script&lang=js"
import style0 from "./Orphans.vue?vue&type=style&index=0&id=add44d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add44d0a",
  null
  
)

export default component.exports